export default [
	/* 边学边赚钱 开始*/
	{
		path: '/learn_makemoney',
		name: 'LearnMakemoney',
		component: (resolve) => require(['@/components/learnAndmoney'], resolve),
	},
	{
		path: '/learn_makemoney/detail',
		name: 'LearnMakemoneyDetail',
		component: (resolve) => require(['@/components/learnAndmoney/articleDetail'], resolve),
	},
	{
		path: '/learn_makemoney/share',
		name: 'LearnMakemoneyShare',
		component: (resolve) => require(['@/components/learnAndmoney/shareLanding'], resolve),
	},
	/* 边学边赚钱 结束*/
	{
		path: '/experience-gold',
		name: 'ExperienceGold',
		component: (resolve) => require(['@/components/ExperienceGoldPage'], resolve),
	},
	{
		path: '/experience-gold-withdraw',
		name: 'ExperienceGoldWithdraw',
		component: (resolve) => require(['@/components/ExperienceGoldPage/withdraw'], resolve),
	},
	{
		path: '/mobile-site',
		name: 'MobileSite',
		component: (resolve) => require(['@/components/MobileSite/index.vue'], resolve),
	},
];



// WEBPACK FOOTER //
// ./src/router/modules/fission.js